// import {getStore} from '@/utils/utils.js'

export const userButton = { 
    data() {
        return {
            g_userBtn:{}
        }
    },
    created() {
        // this.getCurrentUserButtonInfo()
    },
    methods: {
        // getCurrentUserButtonInfo(){
        //     this.g_userBtn = JSON.parse(getStore('loginUser'))['buttonPermission']
        // }
    }
}